/**
 * Shape of the errors our axios client throws (plus plain Error). Used in
 * `catch` blocks instead of `any` (lint cleanup 2026-09-27).
 */
export interface ApiErrorLike {
  message?: string
  code?: string
  name?: string
  response?: {
    status?: number
    headers?: Record<string, string | undefined>
    data?: {
      // FastAPI `detail` is a string, a list of validation errors, or an
      // object such as the 402 plan-gate payload — callers narrow it.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      detail?: any
      message?: string
      [key: string]: unknown
    }
  }
}

/**
 * The readable message from an API error: the server's `detail` when it is a
 * string (including the 503 "not configured" fallback from
 * backend/app/core/config_check.py), otherwise `fallback`.
 */
export function apiErrorMessage(errRaw: unknown, fallback: string): string {
  const detail = (errRaw as ApiErrorLike | null)?.response?.data?.detail
  return typeof detail === 'string' && detail.trim() ? detail : fallback
}

/** True when the server answered 503 because a feature's keys aren't set. */
export function isNotConfigured(errRaw: unknown): boolean {
  const res = (errRaw as ApiErrorLike | null)?.response
  return res?.status === 503 && res?.data?.code === 'not_configured'
}
